import React from 'react';
import Sidebar from '../Components/Sidebar/Sidebar';
import ChatGemini from '../Components/ChatGemini/ChatGemini';
import { ensureProtocol } from '../../config/backend';
import './chat.css';

function Chat() {
  const baseUrl = ensureProtocol(localStorage.getItem('ipBackend2') || '');

  return (
    <div className="app-layout">
      <Sidebar />
      <main className="main-content">
        <div className="container-fluid tacoma-page chat-page">
          <div className="page-header tacoma-page-header">
            <h1 className="tacoma-page-title">Fale com Tacoma</h1>
            <p className="chat-page-subtitle">Peça auxílio ao assistente: ele busca em chamados atendidos, na internet ou responde com conhecimento próprio.</p>
          </div>
          <div className="chat-page-content">
            <ChatGemini
              apiBaseUrl={baseUrl}
              chatPath="/satis/chat-gemini"
              role="analista"
            />
          </div>
        </div>
      </main>
    </div>
  );
}

export default Chat;
